import { ComponentsSdkTypes, type MachineContext, type MachineEvents } from '../types';

const shouldShowSandbox = (context: MachineContext, event: MachineEvents): boolean => {
  if (event.type !== 'initContextUpdated') {
    return false;
  }

  const { componentsSdkContext, overallOutcome, idDocOutcome } = context;
  const isMobileComponentSdk = componentsSdkContext?.componentsSdkType === ComponentsSdkTypes.MOBILE;
  const skipRelayToComponents = componentsSdkContext?.skipRelayToComponents;
  if (isMobileComponentSdk && skipRelayToComponents) {
    // this means we already have the auth token i.e. we asked for sandbox outcome already before the identify step
    return false;
  }

  const config = context.config || event.payload.config;

  const requiresIdDocOutcome = !!config?.sandboxConfig?.collectDocumentOutcome && !idDocOutcome;
  const showIdDocOutcomePicker = requiresIdDocOutcome && !context.idDocOutcome;

  const requiresOverallOutcome = !!config?.sandboxConfig?.collectSandboxOutcome && !overallOutcome;
  const showOverallOutcomePicker = requiresOverallOutcome && !context.overallOutcome;

  const requiresSandboxId = !!config?.sandboxConfig?.collectSandboxId;
  const showSandboxIdPicker = requiresSandboxId && !context.sandboxId;

  return (
    !config?.isLive &&
    !context.isTransfer &&
    (showIdDocOutcomePicker || showOverallOutcomePicker || showSandboxIdPicker)
  );
};

export default shouldShowSandbox;
